import { getAdobeAnalyticsScript, getIpuaEnvFromHostname } from "./adobe-script-utils";
import { loadRuntimeConfig } from "../utils/runtimeConfig";

document.addEventListener("DOMContentLoaded", async function () {
    const fallbackEnv = import.meta.env.VITE_CUP_ENV || "qa";
    const cupEnv = getIpuaEnvFromHostname(window.location.hostname, fallbackEnv);

    let ipuaBase;
    try {
        const config = await loadRuntimeConfig();
        ipuaBase = config?.VITE_IPUA;
    } catch {
        ipuaBase = undefined;
    }
    if (ipuaBase) {
        const fullUrl = `${ipuaBase}/ipua/latest/${cupEnv}/assets/ipua-panel.js?no-cache=${Date.now()}`;
        var ipua = document.createElement("script");
        ipua.setAttribute("type", "module");
        ipua.setAttribute("src", fullUrl);
        ipua.async = true;
        document.querySelector("head").appendChild(ipua);
    }

    var adobeAnalyticsScript = document.createElement("script");
    adobeAnalyticsScript.setAttribute("src", getAdobeAnalyticsScript(window.location.hostname));
    adobeAnalyticsScript.async = true;
    document.head.appendChild(adobeAnalyticsScript);
});
